/**
 * Hook: useIsWellnessTenant()
 * Returns true if the currently logged-in user belongs to a tenant whose
 * sector is physio / osteo / postural / rehab / wellness.
 * Gates the entire wellness suite (Body Map, Recovery Timeline, Packages…).
 */
import { useAuth } from "../App";

const WELLNESS_SECTOR_SLUGS = new Set([
  "fisioterapista", "fisioterapia", "physio", "physiotherapy",
  "osteopata", "osteopatia", "osteopath",
  "centro_posturale", "posturologia", "posturologo",
  "riabilitazione", "riabilitazione_fisica", "rehab",
  "benessere_fisico", "benessere_posturale", "wellness",
  "chinesiologo", "chinesiologia",
]);

export const useIsWellnessTenant = () => {
  const { user } = useAuth();
  if (!user) return false;
  const sector = (user.tenant_sector || "").toString().trim().toLowerCase();
  return WELLNESS_SECTOR_SLUGS.has(sector);
};
